import { render, staticRenderFns } from "./TabellaTextFieldAuth.vue?vue&type=template&id=48a3b83e&"
import script from "./TabellaTextFieldAuth.vue?vue&type=script&lang=js&"
export * from "./TabellaTextFieldAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports